<template>
  <div class="white-table" :class="{extended: !compact}">
    <div class="white-table-header-wrapper" v-if="!compact">
      <div class="white-table-header">
        <div
          class="qrw-label-sm bold"
          :style="getColumnStyle(col)"
          v-for="(col, index) in columns"
          :key="index"
        >
          {{ col.text }}
        </div>
      </div>
    </div>

    <div class="white-table-body-wrapper" :class="{ extended: !compact }">
      <div class="white-table-body" :class="{ extended: !compact }">
        <div
          class="white-table-row"
          v-for="(row, rowIndex) in rows"
          :key="rowIndex"
          @click="$emit('rowClick', row)"
        >
          <div
            class="white-table-column"
            :style="getColumnStyle(col)"
            v-for="(col, columnIndex) in columns"
            :key="columnIndex"
          >
            <slot :name="`col-${col.key || columnIndex}`" :rowItem="row">
              {{ getColumnContent(row, col, rowIndex, columnIndex) }}
            </slot>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  props: {
    /**
     * Columns definition example:
     *
     * [
     *  {
     *      text: 'Date',
     *      width: '120px'
     *  }
     * ]
     *
     */
    columns: Array,
    rows: Array,
    compact: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    getColumnStyle(col) {
      const style = {};

      if (col.width) {
        if (typeof col.width === "number") {
          style.width = `${col.width}px`;
          style["min-width"] = `${col.width}px`;
        } else {
          style.width = col.width;
          style["min-width"] = col.width;
        }
      } else {
        style.width = `100%`;
      }

      return style;
    },
    getColumnContent(row, column, row_index, column_index) {
      let value = row[column_index] || null;

      if (column.key) value = row[column.key];

      if (column.format) {
        const fmt = column.format;

        if (fmt === "date") value = moment(value).format("DD.MM.YYYY");
        if (fmt === "time") value = moment(value).format("HH:mm");
        if (fmt === "currency") value = `${value} ${this.currency.symbol}`;
        if (fmt === "prefix") value = `${column.prefix} ${value}`;
        if (fmt === "suffix") value = `${value} ${column.suffix}`;
      }

      if (column.renderer) value = column.renderer(row);

      return value;
    },
  },
  computed: {
    currency() {
      return this.$store.state.currency;
    },
  },
};
</script>

<style scoped>
.white-table {
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow: hidden;
}

.white-table.extended {
    height: 100%;
}

.white-table-header {
  background: var(--v1-grey-10-color);
  color: var(--v1-grey-6-color);
  display: flex;
  flex-direction: row;
  column-gap: 24px;
  padding: 16px 24px 16px 24px;
  width: 100%;
  box-sizing: border-box;
  border-radius: 8px;
}

.white-table-body-wrapper.extended {
  overflow-y: auto;
  display: flex;
  width: 100%;
  height: 100%;
}

.white-table-body {
  display: flex;
  flex-direction: column;
  row-gap: 8px;
  width: 100%;
  height: fit-content;  
}

.white-table-body.extended {
  padding: 16px 40px 40px 40px;
}

.white-table-header-wrapper {
    padding: 8px 40px 0 40px;
}

.white-table-row {
  border-radius: 8px;
  padding: 16px 24px;
  display: flex;
  flex-direction: row;
  column-gap: 24px;
  background: var(--v1-grey-2-color);
}
</style>